import axios from 'axios';
import { contructParamsForLDBImpersonating } from 'legacy-src/components/impersonating/utils';

const useFetchStudentAssignments = () => {
  const loadStudentAssignments = ({
    subject,
    status,
    resourceType,
    searchTerm,
    setData,
    setLoading,
    params,
    isImpersonating,
    labels,
  }) => {
    setLoading(true);
    const assessmentsURL = new URL(
      `${FYM_BACKEND_URL}/assessments/api/chameleon/student_assignments/${subject}/`,
    );
    !labels && status && assessmentsURL.searchParams.append('status', status);
    labels && assessmentsURL.searchParams.append('labels', labels);
    resourceType && assessmentsURL.searchParams.append('type', resourceType);
    searchTerm && assessmentsURL.searchParams.append('search', searchTerm);

    let _params;
    if (isImpersonating) {
      // pass impersonating details so we can add it to the ldb secure url for secure assignments
      _params = { ...params, ...contructParamsForLDBImpersonating() };
    } else {
      _params = params;
    }

    axios.get(assessmentsURL.href, _params).then(({ data }) => {
      setData(data);
      setLoading(false);
    });
  };

  return [loadStudentAssignments];
};

export default useFetchStudentAssignments;
